import React from "react";
import moment from "moment";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { toFloat } from "validator";
import { useTranslation } from 'react-i18next';


const PurchaseHistoryTable = ({ tableData, searchQuery, defaultSorted }) => {
  const { ExportCSVButton } = CSVExport;

  const { t } = useTranslation();

  const amountFormatter = (cell, row) => (
    <b>{toFloat(cell).toFixed(2)} €</b>
  );

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };
  
  const receiptFormatter = cell =>
    cell ?
    (
      <a href={cell} target="blank">
      <Button className="btn-status" color="primary">
        <b>{t("purchaseHistory.view.table.button.view")}</b>
      </Button>
      </a>
    ) : null;

  const columns = [    
    {
      dataField: "amount",
      text: t("purchaseHistory.view.table.column.amount"),
      sort: true,
      formatter: amountFormatter,
    },
    {
      dataField: "description",
      text: t("purchaseHistory.view.table.column.description"),
      sort: false,
    },
    {
      dataField: "credits_balance",
      text: t("purchaseHistory.view.table.column.credits_balance"),
      sort: false,
    },
    {
      dataField: "tokens_balance",
      text: t("purchaseHistory.view.table.column.tokens_balance"),
      sort: false,
    },
    {
      dataField: "created",
      text: t("purchaseHistory.view.table.column.date_of_purchase"),
      sort: true,
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
    },
    {
      dataField: "stripe_receipt_url",
      text: t("purchaseHistory.view.table.column.receipt"),
      sort: false,
      formatter: receiptFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "amount" || sortField === "credits_balance" || sortField === "created") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
  }

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={ {
        fileName: 'purchase-history.csv',
      } }
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input placeholder={t("purchaseHistory.view.table.placeholder.search")} value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton
                  className="btn btn-outline-info"
                  {...props.csvProps}
                >
                  {t("purchaseHistory.view.table.button.export_csv")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={ false }
            remote={ { sort: true } }
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default PurchaseHistoryTable;
